export enum Unit {
  Metres = 0,
  Yards = 1,
  CentiMetres = 2,
}

export const unitOptions = [
  { label: 'Metres', value: Unit.Metres },
  { label: 'Yards', value: Unit.Yards },
]

export const fabricWidthOptions = [
  { label: 'Centimetres', value: Unit.CentiMetres },
]